var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Router } from "@dooboostore/core-web";
import { UrlUtils } from "@dooboostore/core";
class ElementRouter extends Router {
  constructor(config) {
    super(config);
    __publicField(this, "_history", []);
    __publicField(this, "_currentIndex", -1);
    if (config.firstUrl) {
      this._history.push({ url: config.firstUrl, data: null, title: void 0 });
      this._currentIndex = 0;
    }
  }
  // Override pushState to manage internal history
  pushState(data, title, path, config) {
    const behaviorSubject = this.behaviorSubject;
    if (!config?.noEventAndPublish && behaviorSubject) {
      behaviorSubject.next({ ...this.getRouteData({ pathOrUrl: path }), triggerPoint: "start" });
    }
    if (!this._history) this._history = [];
    this._history = this._history.slice(0, this._currentIndex + 1);
    this._history.push({ url: path, data, title });
    this._currentIndex++;
    if (!config?.noEventAndPublish && behaviorSubject) {
      behaviorSubject.next({ ...this.getRouteData({ pathOrUrl: path }), triggerPoint: "end" });
    }
    return { data };
  }
  // Override replaceState to manage internal history
  replaceState(data, title, path, config) {
    const behaviorSubject = this.behaviorSubject;
    if (!config?.noEventAndPublish && behaviorSubject) {
      behaviorSubject.next({ ...this.getRouteData({ pathOrUrl: path }), triggerPoint: "start" });
    }
    if (!this._history) this._history = [];
    if (this._currentIndex === -1) {
      this._history.push({ url: path, data, title });
      this._currentIndex = 0;
    } else {
      this._history[this._currentIndex] = { url: path, data, title };
    }
    if (!config?.noEventAndPublish && behaviorSubject) {
      behaviorSubject.next({ ...this.getRouteData({ pathOrUrl: path }), triggerPoint: "end" });
    }
    return { data };
  }
  push(path, state) {
    this.pushState(state?.data, state?.title, this.toUrl(path), state?.config);
  }
  replace(path, state) {
    this.replaceState(state?.data, state?.title, this.toUrl(path), state?.config);
  }
  back(config) {
    if (this._currentIndex > 0) {
      this.go(-1, config);
    }
  }
  forward(config) {
    if (this._currentIndex < this._history.length - 1) {
      this.go(1, config);
    }
  }
  go(config, changeStateConfig) {
    if (typeof config === "number") {
      const targetIndex = this._currentIndex + config;
      if (this._history && targetIndex >= 0 && targetIndex < this._history.length) {
        const behaviorSubject = this.behaviorSubject;
        if (!changeStateConfig?.noEventAndPublish && behaviorSubject) {
          behaviorSubject.next({ ...this.getRouteData(), triggerPoint: "start" });
        }
        this._currentIndex = targetIndex;
        const entry = this._history[this._currentIndex];
        if (!changeStateConfig?.noEventAndPublish && behaviorSubject) {
          behaviorSubject.next({ ...this.getRouteData({ pathOrUrl: entry.url }), triggerPoint: "end" });
        }
      }
      return;
    }
    return super.go(config, changeStateConfig);
  }
  getData() {
    return this._history?.[this._currentIndex]?.data;
  }
  getUrl() {
    return this._history?.[this._currentIndex]?.url ?? this.config?.firstUrl ?? "/";
  }
  getHref() {
    return this.getUrl();
  }
  getPathName() {
    return this.getUrl().split("?")[0];
  }
  getSearch() {
    const parts = this.getUrl().split("?");
    return parts[1] ? `?${parts[1]}` : "";
  }
  getSearchParams(data) {
    const search = this.getSearch();
    const searchParams = new URLSearchParams(search);
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
  getHashSearchParams(data) {
    const url = this.getUrl();
    const hashIdx = url.indexOf("#");
    const hash = hashIdx !== -1 ? url.slice(hashIdx + 1) : "";
    const searchParams = new URLSearchParams(hash);
    return UrlUtils.manipulateSearchParams(searchParams, data);
  }
  pushAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.push({ searchParams: s }, state);
  }
  pushDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const url = this.getUrl().split("#")[0];
    const size = Array.from(s.entries()).length;
    this.push(url + (size > 0 ? "#" + s.toString() : ""), state);
  }
  pushDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.push({ searchParams: s }, state);
  }
  pushUpsertSearchParam(params, state) {
    const s = this.getSearchParams();
    UrlUtils.upsertSearchParam(s, params);
    this.push({ searchParams: s }, state);
  }
  replaceAddSearchParam(params, state) {
    const s = this.getSearchParams({ append: params });
    this.replace({ searchParams: s }, state);
  }
  replaceDeleteHashSearchParam(name, state) {
    const s = this.getHashSearchParams({ delete: Array.isArray(name) ? name : [name] });
    const url = this.getUrl().split("#")[0];
    const size = Array.from(s.entries()).length;
    this.replace(url + (size > 0 ? "#" + s.toString() : ""), state);
  }
  replaceDeleteSearchParam(name, state) {
    const s = this.getSearchParams({ delete: Array.isArray(name) ? name : [name] });
    this.replace({ searchParams: s }, state);
  }
  replaceUpsertSearchParam(params, state) {
    const s = this.getSearchParamObject();
    UrlUtils.upsertSearchParam(s, params);
    this.replace({ searchParams: s }, state);
  }
}
export {
  ElementRouter
};
//# sourceMappingURL=ElementRouter.js.map
